import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { Appointment, Schedule } from '../../appointment/model/appointment';
import { AppointmentService } from '../../appointment/service/appointment.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
@Component({
  selector: 'app-pending',
  templateUrl: './pending.component.html'
})
export class PendingComponent implements OnInit {
 
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  appointments : Appointment[];
  selectedAppObject : Appointment;
  isSuccessMessage : boolean = false;
  isErrorMessage : boolean = false;
  apploading : boolean = false;
  isAdd : boolean = true;
  userClinic= null;
  appDate: any;
  id: number;
  private sub: any;
  user : any ; 
  constructor(private _sharedService: SharedService,private _appService : AppointmentService) {  }


  ngOnInit() {
    this.getPendingdAppointment();
  }
  getPendingdAppointment() : void {
    this.apploading = true;
     this._appService.getPendingdAppointment().subscribe(data=>{
       this.appointments = data;
       this.apploading = false;
     },error=>{

     });
  }

  showAppointment(appId: number) {
    window.open("#/Prescription/"+appId,"_blank","width:100%");
  }
  showHistory(appId: number) {
    window.open("https://www.theaurapower.com/Patient/History?AppointmentId="+appId,"_blank","width:100%");
  }
   
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/pending/pending.component.ts